<template>
    <div id="pwa-intervention" class="mx-2">
        <button-go-back text="Planning"></button-go-back>

	    <intervention-informations :intervention="intervention"></intervention-informations>

	    <template v-if="intervention.withDetails">

		    <md-divider class="mt-3 mb-3"></md-divider>

	        <template v-if="intervention.status_id !== 6">
		        <div class="md-layout md-gutter">
			        <div class="md-layout-item md-size-50">
				        <div class="intervention-details__card__actions red" :class="{'cursor-default': hasReportModel || !devices.hasDevices}"
				             v-on="devices.hasDevices && !hasReportModel ? { click: () => goToRoute('Pwa Intervention Devices Details') } : {}">
					        <div class="leading-none text-sm">
						        <p class="leading-4 mb-0">{{ textDevices }}</p>
						        <small v-if="devices.hasDevices && hasReportModel" class="text-danger leading-none">Non modifiable</small>
					        </div>
					        <div class="done-icon" :class="{'block': (devices.checked.sameInterventionType.length >= totalNeededDevices) }">
						        <md-button class="md-icon-button md-small-icon md-rounded-icon my-0 md-success cursor-default">
							        <font-awesome-icon class="md-icon" :icon="['fa', 'check-circle']" />
						        </md-button>
					        </div>
					        <div class="done-icon" :class="{'block': (devices.checked.sameInterventionType.length < totalNeededDevices) && hasReportModel }">
						        <md-button class="md-icon-button md-small-icon md-rounded-icon my-0 md-danger cursor-default">
							        <font-awesome-icon class="md-icon" :icon="['fa', 'times-circle']" />
						        </md-button>
					        </div>
				        </div>
			        </div>
			        <div class="md-layout-item md-size-50">
				        <div class="intervention-details__card__actions orange" :class="{'cursor-default': hasReportModel}"
				             v-on="!hasReportModel ? { click: () => goToRoute('Pwa Intervention Report') } : {}">
					        <div class="leading-none text-sm">
						        <p class="leading-4 mb-0">{{ hasReportModel ? 'Rapport saisi' : 'Rapport' }}</p>
						        <small v-if="hasReportModel" class="text-danger leading-none cursor-pointer"
						               @click="showDeleteModal = true">Supprimer</small>
					        </div>
					        <div class="done-icon" :class="{ 'block': hasReportModel }">
						        <md-button class="md-icon-button md-small-icon md-rounded-icon my-0 md-success cursor-default">
							        <font-awesome-icon class="md-icon" :icon="['fa', 'check-circle']" />
						        </md-button>
					        </div>
				        </div>
				        <md-dialog-confirm class="dialog-pwa"
				                           :md-active.sync="showDeleteModal"
				                           :md-content="`<p class='font-medium'>Supprimer le rapport ?</p><p class='text-xs'>Seul le rapport sera supprimé.</p>`"
				                           md-confirm-text="Supprimer"
				                           md-cancel-text="Annuler"
				                           @md-confirm="deleteReport" />
			        </div>
		        </div>

		        <div class="md-layout md-gutter mt-3">
			        <div class="md-layout-item md-size-50">
				        <div class="intervention-details__card__actions green" :class="{'cursor-default': hasReportSignature}"
				             v-on="!hasReportSignature ? { click: () => goToRoute('Pwa Intervention Signature') } : {}">
					        <span class="text-sm">{{ hasReportSignature ? 'Intervention signée' : 'Signature' }}</span>
					        <div class="done-icon" :class="{'block': hasReportSignature }">
						        <md-button class="md-icon-button md-small-icon md-rounded-icon my-0 md-success cursor-default">
							        <font-awesome-icon class="md-icon" :icon="['fa', 'check-circle']" />
						        </md-button>
					        </div>
				        </div>
			        </div>
			        <div class="md-layout-item md-size-50">
				        <div class="intervention-details__card__actions purple" :class="{'cursor-default': (!hasReportModel || !hasReportSignature) || intervention.status_id === 6}"
				             v-on="hasReportSignature && hasReportModel ? { click: () => goToRoute('Pwa Intervention Closure') } : {}">
					        <div class="leading-none text-sm">
						        <p class="leading-4 mb-0">{{ hasReportModel && hasReportSignature ? 'Cloturer' : 'Cloture impossible' }}</p>
						        <small v-if="devices.hasDevices && hasReportModel && hasReportSignature && (devices.checked.sameInterventionType < totalNeededDevices)"
						               class="text-danger leading-none">Dispositifs manquant</small>
					        </div>
					        <div class="done-icon" :class="{'block': intervention.status_id === 6 }">
						        <md-button class="md-icon-button md-small-icon md-rounded-icon my-0 md-success cursor-default">
							        <font-awesome-icon class="md-icon" :icon="['fa', 'check-circle']" />
						        </md-button>
					        </div>
				        </div>
			        </div>
		        </div>
	        </template>

		    <div v-else class="md-layout md-gutter mt-3">
			    <div class="md-layout-item md-size-100">
				    <div class="intervention-details__card__actions red cursor-default">
					    <span class="text-sm">Intervention terminée</span>
					    <div class="done-icon block">
						    <md-button class="md-icon-button md-small-icon md-rounded-icon my-0 md-success cursor-default">
							    <font-awesome-icon class="md-icon" :icon="['fa', 'check-circle']" />
						    </md-button>
					    </div>
				    </div>
			    </div>
		    </div>

		    <div class="md-layout md-gutter mt-3">
			    <div class="md-layout-item md-size-100">
				    <div class="intervention-details__card__actions blue" @click="goToRoute('Pwa Intervention Demand')">
					    <span class="text-sm">Ajouter une demande</span>
				    </div>
			    </div>
		    </div>

	    </template>

	    <md-divider class="mt-3 mb-3"></md-divider>

	    <div class="md-layout md-gutter">
		    <div class="md-layout-item md-size-100">
			    <div class="intervention-details__card">
				    <p class="font-medium mb-2 text-sm">Plans du site</p>
				    <md-divider class="mb-1.5 -mt-1 -mx-2"></md-divider>
				    <template v-if="intervention.site.plans.length > 0">
					    <div v-for="plan in intervention.site.plans" :key="plan.id"
					         class="leading-4 mb-3">
						    <div class="flex items-center justify-between">
							    <div class="flex items-center mr-1">
								    <md-button class="md-icon-button md-small-icon md-rounded-icon my-0 md-primary" :disabled="!plan.pdf"
								               :href="plan.pdf" target="_blank">
									    <font-awesome-icon class="md-icon" :icon="['fa', 'file-pdf']" />
								    </md-button>
								    <div class="ml-1.5">
									    <p class="leading-4 text-sm">{{ plan.name }}</p>
									    <p class="mb-0 mt-0.5 text-danger text-xs leading-none" v-if="!plan.pdf">Plan indisponible, fichier source manquant (png, jpg...)</p>
								    </div>
							    </div>
							    <md-button v-if="intervention.withDetails" class="md-icon-button md-small-icon md-rounded-icon my-0 md-warning" :disabled="!plan.url"
							               @click="goToRoute('Pwa Intervention Site Plan', { planId: plan.id })">
								    <font-awesome-icon class="md-icon" :icon="['fa', 'pen']" />
							    </md-button>
						    </div>
					    </div>
				    </template>
				    <div v-else class="leading-none mb-1 text-sm">
					    <span>Aucun plan disponible</span>
				    </div>
			    </div>
		    </div>
	    </div>

	    <div class="md-layout md-gutter mt-2">
		    <div class="md-layout-item md-size-100">
			    <div class="intervention-details__card">
				    <p class="font-medium mb-2 text-sm">Derniers rapports</p>
				    <md-divider class="mb-1 -mt-1 -mx-2"></md-divider>
				    <template v-if="intervention.lastReports.length > 0">
					    <div v-for="report in intervention.lastReports" :key="report.id"
					         class="leading-4 mb-2.5">
						    <div class="flex items-center">
							    <md-button class="md-icon-button md-small-icon md-rounded-icon my-0 md-primary"
							               :href="report.url" target="_blank" :disabled="!report.url">
								    <font-awesome-icon class="md-icon" :icon="['fa', 'file-pdf']"/>
							    </md-button>
							    <div class="ml-1.5">
								    <p class="leading-4 text-sm mb-0.5">{{ `${$moment(report.date).format('DD/MM/YYYY')} - ${report.interventionType}` }}</p>
								    <p v-if="!report.url" class="mb-0 text-danger text-xs leading-none">Rapport PDF indisponible</p>
							    </div>
						    </div>

					    </div>
				    </template>
				    <div v-else class="leading-none mb-1 text-sm">
					    <span>Aucun rapport disponible</span>
				    </div>
			    </div>
		    </div>
	    </div>

        <div class="calendar-overlay opacity-100 fixed z-50 w-full h-full" v-if="updating">
            <div class="h-full w-full flex items-center justify-center">
                <md-progress-spinner class="md-white" md-mode="indeterminate"
                                     :md-diameter="65" :md-stroke="5"></md-progress-spinner>
            </div>
        </div>
    </div>
</template>

<script>
import ButtonGoBack from "../components/ButtonGoBack";
import InterventionInformations from "@/pages/ProgressiveWebApp/Planning/components/InterventionInformations";

import dateTimeFormattingMixin from '@/mixins/date-time-formatting-mixin'
import indexedDBMixin from "@/mixins/indexed-db-mixin";

export default {
    name: "PwaInterventionDetails",
    components: { InterventionInformations, ButtonGoBack },
    mixins: [dateTimeFormattingMixin, indexedDBMixin],
    data() {
        return {
            intervention: {
                site: {
                    address: {},
                    schedules: [],
                    contacts: [],
                    plans: []
                },
                client: {},
                contract: {},
                intervention_type: {},
                category: {},
                planningable: {},
                lastReports: [],
                report: null,
	            withDetails: true,
            },
	        devices: {
				hasDevices: true,
				checked: {
					sameInterventionType: [],
					notSameInterventionType: []
				},
		        notChecked: {
			        sameInterventionType: [],
			        notSameInterventionType: []
		        }
	        },
            updating: true,
            showDeleteModal: false
        }
    },
    computed: {
        hasReportModel() {
            return !!(this.intervention.report && this.intervention.report.model_value)
        },
        hasReportSignature() {
            return !!(this.intervention.report && this.intervention.report.report_signature)
        },
	    totalNeededDevices() {
			return this.devices.checked.sameInterventionType.length + this.devices.notChecked.sameInterventionType.length
	    },
        textDevices() {
            return this.devices.hasDevices ? `Dispositifs : ${this.devices.checked.sameInterventionType.length + this.devices.checked.notSameInterventionType.length}
                / ${this.totalNeededDevices}`
                : 'Aucun dispositif'
        }
    },
    methods: {
        async getInterventionDetails() {
	        const intervention = await this.fetchDataFromIndexedDB(`pwa/intervention/${this.$route.params.interventionId}`)
	        const site = await this.fetchDataFromIndexedDB(`pwa/intervention/${this.$route.params.interventionId}/site`)
	        const lastReports = await this.fetchDataFromIndexedDB(`pwa/intervention/${this.$route.params.interventionId}/lastReports`)

	        this.intervention = {
				...intervention.value,
		        site: {
					...site.value,
			        schedules: this.formatSchedules(site.value.schedules)
		        },
		        lastReports: lastReports.value
	        }

			if(this.intervention.withDetails) {
				const devices = await this.fetchDataFromIndexedDB(`pwa/intervention/${this.$route.params.interventionId}/devices`)
				this.devices = devices.value
			}

            this.updating = false
        },
        async deleteReport() {
			const payload = {
				access_token: JSON.parse(localStorage.getItem('pwa')).access_token,
				intervention_id: this.intervention.id
			}

            try {
	            const intervention = await this.fetchDataFromIndexedDB(`pwa/intervention/${this.intervention.id}`)
	            intervention.value.report = { ...intervention.value.report, model_value: null }
	            const db = await this.getIndexedDBConnection()
	            const tx = db.transaction('data', 'readwrite')
	            const store = tx.objectStore('data')
	            store.put({ key: `pwa/intervention/${this.intervention.id}`, value: intervention.value })

	            await this.getRequestsInIndexedDB('requests').then(async (requests) => {
		            const sendReportRequest = requests.find(request =>
			            request.key.includes('report') &&
			            !request.key.includes('device') &&
			            !request.key.includes('delete') &&
			            request.key.includes(this.intervention.id)
		            )

		            if(sendReportRequest) {
			            await this.deleteRequestInIndexedDB(`pwa/planning/${this.intervention.id}/report`)
		            } else {
			            await this.storeRequest(`pwa/intervention_reports/delete`, payload)
		            }
	            })

                await this.$store.dispatch('alerts/success', 'Rapport supprimé')
                this.updating = true
                await this.getInterventionDetails()
            } catch (e) {}
        },
        goToRoute(route, params = {}) {
            this.$router.push({ name: route, params })
        },
    },
     mounted() {
        this.getInterventionDetails()
     }
}
</script>

<style scoped lang="scss">

</style>
